import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const EDITABLE = 'input, textarea, select, [contenteditable="true"]';
const MEDIA = 'img, picture, video, svg, canvas, [style*="background-image"]';

// Discourages copying artwork photos and text on public pages (admin is exempt).
export const ContentProtection = () => {
  const { pathname } = useLocation();
  const active = !pathname.startsWith('/admin');

  useEffect(() => {
    document.documentElement.classList.toggle('protect-content', active);
    if (!active) return undefined;
    const inEditable = (t) => t instanceof Element && t.closest(EDITABLE);
    const onContext = (e) => {
      if (!inEditable(e.target)) e.preventDefault();
    };
    const onDrag = (e) => {
      if (e.target instanceof Element && e.target.closest(MEDIA)) e.preventDefault();
    };
    const onCopy = (e) => {
      if (!inEditable(e.target)) e.preventDefault();
    };
    document.addEventListener('contextmenu', onContext);
    document.addEventListener('dragstart', onDrag);
    document.addEventListener('copy', onCopy);
    document.addEventListener('cut', onCopy);
    return () => {
      document.removeEventListener('contextmenu', onContext);
      document.removeEventListener('dragstart', onDrag);
      document.removeEventListener('copy', onCopy);
      document.removeEventListener('cut', onCopy);
    };
  }, [active]);

  return null;
};

export const Watermark = () => (
  <div
    aria-hidden="true"
    className="pointer-events-none select-none absolute inset-0 flex items-center justify-center overflow-hidden"
    data-testid="artwork-watermark"
  >
    <span
      className="font-serif uppercase whitespace-nowrap text-white/40 text-sm sm:text-lg tracking-[0.4em] -rotate-[28deg]"
      style={{ textShadow: '0 0 2px rgba(0,0,0,0.25)' }}
    >
      Zebra One Gallery
    </span>
  </div>
);
